import { JsonDiscriminatorValue, JsonObject } from "ta-json";

import DataType from "../data-type";
import { PropertyDefinition } from "../property-definition";

/**
 * Boolean property definition.
 */
@JsonObject()
@JsonDiscriminatorValue(DataType.Boolean)
export class BooleanPropertyDefinition extends PropertyDefinition {
    constructor(name: string, init?: Omit<Partial<BooleanPropertyDefinition>, "name">) {
        super(name, DataType.Boolean);
        Object.assign(this, init);
    }
}
